import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import LegalPage from "./pages/LegalPage";
import { Toaster } from "./components/ui/toaster";
import CookieBanner from "./components/CookieBanner";
import TawkChat from "./components/TawkChat";
import FloatingCallButton from "./components/FloatingCallButton";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/mentions-legales" element={<LegalPage type="mentions" />} />
          <Route path="/politique-confidentialite" element={<LegalPage type="privacy" />} />
          <Route path="/cgv" element={<LegalPage type="cgv" />} />
          <Route path="/cookies" element={<LegalPage type="cookies" />} />
        </Routes>
        <CookieBanner />
        <TawkChat />
        <FloatingCallButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
